export enum TransportationUsage {
  NoUsage,
  OneWay,
  TwoWay,
}
